export class ContractTerminationModel {
  id: number;
  keycloakClientId: string;
  sentByAdvisorId: string;
  subject: string;
  message: string;
  sentEmailTo: string;
  created: string;
  insuranceProviderId: number;
  insuranceProviderName: string;
  contractId: number;
  contractUid: string;
  clientFirstName: string;
  clientLastName: string;
  clientEmail: string;
  status: 'OPEN' | 'CLOSED';
  isCollapsed?: boolean;
}

export class ContractTerminationRequestModel {
  keycloakClientId: string;
  contractUId: string;
  insuranceProviderId: number;
  subject: string;
  reminder: 'WEEKLY' | 'BI_WEEKLY' | 'MONTHLY' | null;
  message: string;
  status: 'OPEN' | 'CLOSED';
  sentEmailTo: string;
  ccEmails: string[] = [];
  /** Create a Wiedervorlage after the email is sent. */
  createFollowUp?: boolean;
}

export class ContractTerminationListRequestModel {
  page: number;
  page_size: number = 25;
  status: 'OPEN' | 'CLOSED';
  sort_direction: 'ASC' | 'DESC' = 'DESC';
  sort_by: 'created' | 'status' | 'clientFirstName' | 'clientLastName' | 'clientEmail' | 'insuranceProviderName' =
    'created';
}

export class ContractTerminationListResponseModel {
  data: ContractTerminationModel[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

// --- New: Kündigungsalarme (GET /b2b/contracts/termination/alerts) ---

export type ContractTerminationAlertSortBy =
  | 'created'
  | 'reminderDate'
  | 'clientFirstName'
  | 'clientLastName'
  | 'insuranceGroupName'
  | 'insuranceProviderName';

export class ContractTerminationAlertModel {
  id: number;
  created: string;
  note: string;
  active: boolean;
  periodOfNotice: 'ONCE' | 'WEEKLY' | 'BI_WEEKLY' | 'MONTHLY' | null;
  reminderDate: string | null;
  contractId: number;
  contractUid: string;
  insuranceGroupName: string | null;
  insuranceProviderName: string | null;
  keycloakClientId: string;
  clientFirstName: string;
  clientLastName: string;
  clientEmail: string;
}

export class ContractTerminationAlertListRequestModel {
  page: number = 0;
  page_size: number = 20;
  sort_by: ContractTerminationAlertSortBy = 'reminderDate';
  sort_direction: 'ASC' | 'DESC' = 'ASC';
  search?: string;
  active: boolean = true;
}

export class ContractTerminationAlertListResponseModel {
  data: ContractTerminationAlertModel[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}
